module.exports = __webpack_public_path__ + "img/first-image.ace6ff94.png";